import isNil from 'lodash/fp/isNil';
import CollatorOptions = Intl.CollatorOptions;

export const compare = (left: string, right: string, caseSensitive = true) => {
    const hasLeft = !isNil(left);
    const hasRight = !isNil(right);

    if (hasLeft && hasRight) {
        const options: CollatorOptions = {
            sensitivity: caseSensitive ? 'variant' : 'accent',
        };

        return left.localeCompare(right, [], options);
    }

    if (hasLeft) return 1;
    if (hasRight) return -1;
    return 0;
};

export const areEqual = (left: string, right: string, caseSensitive = true) =>
    compare(left, right, caseSensitive) === 0;
